import { Component } from '@angular/core';
import { MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: 'lex-doc-viewer-dialog',
    templateUrl: './doc-viewer-dialog.component.html',
    styleUrls: ['./doc-viewer-dialog.component.scss'],
    standalone: false
})
export class DocViewerDialogComponent {

	public closeButtonTip = 'Are you sure?';
	public hideCancel = false;
	public showAcknowledge = false;
	public acknowledged = false;
	
	constructor(private dialogRef: MatDialogRef<DocViewerDialogComponent>) {
		dialogRef.addPanelClass('doc-viewer-dialog');
	}

	public ok(): void {
			this.dialogRef.close(true);
	}

	public close(): void {
		this.dialogRef.close(false);
	}
}